declare global {
  /**
   * @description
   * Global commandline environment variables available to
   * devserver build at runtime
   *
   */
  export const APP_ENV: {
    /**
     * @description
     * Set an OXIO namespace to attach to request header
     */
    OXIO_NAMESPACE?: string;
    RELEASE_VERSION?: string;
    APM_URL?: string;
  };
}

export const DEFAULT_APP_ENV: typeof APP_ENV = {};
